import { forwardRef } from "react";
import { StyledIconButton } from "./styles";
import type { IconButtonProps } from "./types";

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ size = "medium", type = "button", ...props }, ref) => (
    <StyledIconButton ref={ref} type={type} $size={size} {...props} />
  ),
);

IconButton.displayName = "IconButton";
